export const WORKFLOW_STATUSES = [
  { value: "RECORDED", label: "Recorded" },
  { value: "ACCEPTED", label: "Accepted" },
  { value: "STARTED", label: "Started" },
  { value: "ON_HOLD", label: "On hold" },
  { value: "STUCK", label: "Stuck" },
  { value: "DESIGNING", label: "Designing" },
  { value: "WEAVING", label: "Weaving" },
  { value: "DYEING", label: "Dyeing" },
  { value: "FINISHING", label: "Finishing" },
  { value: "OTHER", label: "Other" },
  { value: "COMPLETED", label: "Completed / sent" },
  { value: "CANCELLED", label: "Cancelled" },
] as const;

export const workflowLabel = (status?: string, customStageLabel?: string): string => {
  if (status === "OTHER" && customStageLabel) {
    return customStageLabel;
  }
  const match = WORKFLOW_STATUSES.find((item) => item.value === status);
  return match?.label || "Recorded";
};

export const newColourLine = () => ({
  id: `line-${Date.now()}-${Math.random().toString(16).slice(2)}`,
  colour: "",
  quantity: "",
  workflowStatus: "RECORDED",
  stuckReason: "",
  customStageLabel: "",
});

export type WorkflowExtras = {
  cancelled: boolean;
  stuckReason?: string;
  customStageLabel?: string;
};

export const askWorkflowExtras = (status: string): WorkflowExtras => {
  if (status === "STUCK") {
    const reason = window.prompt("Why is this order stuck?");
    if (reason == null || !reason.trim()) {
      return { cancelled: true };
    }
    return { cancelled: false, stuckReason: reason.trim() };
  }
  if (status === "OTHER") {
    const label = window.prompt("Name this stage");
    if (label == null || !label.trim()) {
      return { cancelled: true };
    }
    return { cancelled: false, customStageLabel: label.trim() };
  }
  return { cancelled: false };
};
